import PropTypes from 'prop-types'
import React, { useState } from "react"
import { ControlLabel, FormControl, FormGroup } from 'react-bootstrap'
import SweetAlert from "react-bootstrap-sweetalert"
import { useTranslation } from 'react-i18next'
import { CustomSelect } from '../CustomControls/CustomSelect'
import { FormErrorMessage } from '../Validations/FormValidationErrors'

export const ConfirmRemove = (props) => {
    const { t } = useTranslation();
    const [inputValue, setInputValue] = useState(null);
    const [selectedValue, setSelectedValue] = useState(null);
    const [error, setError] = useState(null);

    const onInputChange = (evt) => {
        setError(null);
        setInputValue(evt.currentTarget.value);
    }

    const onSelectChange = (_name, value) => {
        setInputValue(null);
        setError(null);
        setSelectedValue(value);
    }

    // Error de carga (id 1) no pide motivo; cancelación por paciente o médico, sí (obligatorio, sin contar espacios).
    const requiresReason = !!selectedValue && selectedValue.id !== 1;
    const reason = inputValue?.trim() ?? '';
    const isValid = !!selectedValue && (!requiresReason || reason.length > 0);
    // El usuario escribió y borró el motivo: se avisa sin esperar a Confirmar (que igual queda deshabilitado).
    const showReasonRequired = requiresReason && inputValue !== null && reason.length === 0;

    const handleOnConfirm = () => {
        // El botón queda deshabilitado mientras no sea válido; esto cubre confirmar con Enter.
        if (!selectedValue) {
            setError("calendarErrors.event_Cancel_SelectReason");
            return;
        }
        // Cancelación por error de carga.
        if (!requiresReason) {
            props.onConfirm(props.id, "error");
            return;
        }
        // Cancelación por paciente o médico.
        if (!reason) {
            setError("calendarErrors.event_Cancel_NotReason");
            return;
        }
        props.onConfirm(props.id, reason);
    }

    return (
        <React.Fragment>
            <SweetAlert
                title={props.title}
                onConfirm={handleOnConfirm}
                onCancel={() => { props.onClose() }}
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="info"
                confirmBtnText={t("buttons.confirm")}
                cancelBtnText={t("buttons.back")}
                showCancel
                disabled={!isValid}
                allowOutsideClick={false}
            >
                <div style={{ height: '170px' }}>
                    <CustomSelect
                        name="cancelAppointment"
                        placeholder={t('commons.select')}
                        options={[
                            { id: 1, title: t('calendar.reasons.creationError') },
                            { id: 2, title: t('calendar.reasons.canceledByPatient') },
                            { id: 3, title: t('calendar.reasons.canceledByPractitioner') }
                        ]}
                        value={selectedValue}
                        onChange={onSelectChange}
                    />
                    {
                        requiresReason &&
                        <FormGroup>
                            <br />
                            <ControlLabel>{t('calendar.reasons.reason')} <span className="text-danger">*</span></ControlLabel>
                            <FormControl
                                type="textarea"
                                placeholder={t('calendar.reasons.reason')}
                                name="inputMotivo"
                                value={inputValue ?? ''}
                                onChange={onInputChange}
                                rows={3}
                                componentClass={"textarea"}
                            />
                        </FormGroup>
                    }
                    {
                        // FormErrorMessage traduce el key del hijo.
                        (error || showReasonRequired) &&
                        <FormErrorMessage><div key={error ?? "calendarErrors.event_Cancel_NotReason"}></div></FormErrorMessage>
                    }
                </div>
            </SweetAlert>
        </React.Fragment>
    );
}

ConfirmRemove.propTypes = {
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    title: PropTypes.string.isRequired,
};